export default {
  // Page titles
  pageTitle: '遊戲活動管理',
  myActivities: '我的遊戲活動',
  searchPlaceholder: '搜尋遊戲活動',
  addNew: '新增',
  noActivities: '目前沒有遊戲活動',

  // Action menu
  settings: '設定',
  duplicate: '複製',
  copySuffix: '(複製)',
  deleteAction: '刪除',

  // Modal titles
  createActivity: '新增遊戲活動',
  updateActivity: '更新遊戲活動設定',

  // Form fields
  activityName: '活動名稱',
  activityNamePlaceholder: '新遊戲活動',
  questionType: '題目類型',
  gameSettingsEntry: '遊戲詳細內容設定',
  enableEntry: '開放進入活動',
  disableEntryToEditSettings: '若要修改遊戲設定，請先關閉「開放進入活動」',
  settingsLockedWarning: '活動已發布且開放進入，無法修改遊戲設定',

  // Question types
  recognition: '辨識題',
  trueFalse: '是非題',
  multiChoice: '單選題',
  aiGenerated: '自定義',

  // Buttons
  cancel: '取消',
  confirm: '確定',
  publish: '發布短網址',
  gamePreview: '遊戲預覽',

  // Messages
  activityCreated: '活動建立成功',
  activityDeleted: '活動刪除成功',
  gameSettingsComingSoon: '遊戲詳細內容設定功能開發中',
  pushConfirmMessage: '推送後會於遊戲管理頁面產生 1 個活動，確定產生嗎？',

  // Error messages
  activityNameRequired: '活動名稱為必填欄位',
  activityNameTooLong: '活動名稱不可超過 20 個字元',

  // Game selection modal
  selectGameType: '選擇遊戲類型',

  // Game card names
  moleGameCard: '打地鼠',
  starGameCard: '摘星星',
  rocketGameCard: '火箭升空',
  snakeGameCard: '詞彙貪食蛇',
  mazeGameCard: '闖迷宮',
  aiGameCard: '自製遊戲',

  // Game settings panel
  playerCount: '遊戲人數',
  person: '人',
  defaultTemplate: '預設遊戲模板',
  moleGame: '打地鼠',
  starGame: '摘星星',
  snakeGame: '詞彙貪食蛇',
  mazeGame: '闖迷宮',
  rocketGame: '火箭升空',
  aiGame: '自製遊戲',
  allowTemplateChange: '允許變換遊戲模板',
  switchGame: '切換遊戲',
  gameParameters: '遊戲參數設定',
  gameParametersNote: '遊戲參數將在選擇模板後進行設定',

  // Game parameters form
  topic: '主題',
  topicWithActivityName: '主題(即遊戲活動名稱)',
  inputTopic: '請輸入主題',
  correctItems: '答對題目',
  correctItemsPlaceholder: '輸入正答詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目',
  errorItems: '答錯題目',
  errorItemsPlaceholder: '輸入錯誤詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目',
  gameDuration: '遊戲時長',
  second: '秒',
  moleSpeed: '地鼠速度',
  gameSpeed: '遊戲速度',
  speedSlow: '慢速',
  speedMedium: '中速',
  speedFast: '快速',
  speedVeryFast: '超快',
  backgroundSetting: '背景設定',
  forest: '森林',
  desert: '沙漠',
  ocean: '海洋',

  // Validation messages
  wordExists: '此項目已存在',
  maxVocabulary: '正確項目最多 20 個',
  maxErrorVocabulary: '錯誤項目最多 20 個',
  unsubmittedWarning: '發現到輸入框尚有未按下Enter 的詞彙，請確認後再進行操作!',

  // AI Custom Game
  customGameCode: '自製遊戲程式碼',
  customGameCodePlaceholder: '請輸入 HTML/CSS/JavaScript。這裡 HTML 標記可輸入簡單版本或 style 和 script 標籤的完整版本。',

  // Delete confirmation
  deleteConfirmTitle: '刪除活動',
  deleteConfirmMessage: '確定要刪除此活動嗎？刪除後將無法復原。',
  delete: '刪除',
  deleting: '刪除中...',

  // Preview mode
  previewMode: '預覽模式',
  previewRefreshWarning: '提示：重新整理頁面後，預覽資料將被清除，並進入預設展示模式。如需預覽，請從設定再次開啟。',

  // Status indicators
  statusOpen: '已開放',

  // Short URL related messages
  shortUrlCopied: '短網址已複製到剪貼簿',
  copyFailed: '複製失敗，請手動複製',
  shortUrlAutoUpdated: '短網址已自動更新，請重新分享給學生',
  shortUrlGenerated: '短網址已生成，請按確定儲存活動',
  shortUrlPublished: '短網址發布成功',
  shortUrlPublishFailed: '發布短網址失敗，請稍後再試',

  // Activity operation messages
  activityCreateFailed: '建立活動失敗，請稍後再試',
  activityUpdateFailed: '更新活動失敗，請稍後再試',
  activityUpdated: '活動更新成功',
  activityDeleteFailed: '刪除活動失敗，請稍後再試',
  activityDuplicated: '活動複製成功',
  activityDuplicateFailed: '複製活動失敗，請稍後再試',

  // Student info
  enterStudentInfo: '請輸入學生資訊',
  selectStudent: '請選擇學生',
  studentName: '姓名',
  studentNamePlaceholder: '請輸入姓名',
  studentSeatNumber: '座號（選填）',
  seatNumberPlaceholder: '例如：5',
  studentNameRequired: '請輸入姓名',
  seatNumberRequired: '請輸入座號',
  studentNameTooLong: '姓名不可超過 20 字元',
  seatNumberInvalid: '座號必須為 1-3 位數字',
  nameAlreadyUsed: '此姓名已被另一方玩家使用',
  seatNumberAlreadyUsed: '此座號已被另一方玩家使用',
  confirmStudentInfo: '開始遊戲',

  // HT 名單匯入功能
  useHiTeachRoster: '使用 HT 匯入名單',
  requestCurrentRoster: '重新請求目前名單',
  studentList: '學生名單',
  students: '位學生',
  seatNo: '座號',
  rosterEmptyHint: '目前沒有名單資料，請點擊「重新請求目前名單」從 HiTeach 取得',
  rosterNotFound: '未找到 HiTeach 名單，請確認是否從 HiTeach 開啟',
  rosterLoadError: '載入名單時發生錯誤',
  rosterSourceOnlyInHT: '僅在 HT 內可設置名單來源',
  confirmRefreshRoster: '確定要重新從 HiTeach 請求目前名單嗎？',
  requestingRoster: '正在請求名單...',
  refreshRosterError: '請求名單失敗，請稍後再試',
  refreshRosterTimeout: '請求名單逾時，請稍後再試',
  rosterRefreshSuccess: '名單已更新 ({count} 位學生)',
  rosterStillEmpty: '名單仍為空，請確認 HiTeach 是否有設定學生名單',
  clickToRefresh: '點擊重新請求',

  // Activity loading
  activityLoadSuccess: '活動載入成功',
  loadActivitySuccess: '活動載入成功',
  activityNotOpen: '此活動尚未開放進入',
  activityLoadFailed: '載入活動失敗',
  loadActivityFailed: '載入活動失敗，將使用展示模式',

  // Score submission
  scoreSubmitted: '成績提交成功',
  scoreSubmitFailed: '成績提交失敗，請稍後再試',

  // Scores panel
  viewScores: '檢視成績表現',
  scoresTitle: '成績表現',
  loadingScores: '載入成績中...',
  noScoresYet: '目前尚無成績資料',
  totalSubmissions: '提交人數',
  averageScore: '平均分數',
  highestScore: '最高分',
  rank: '排名',
  seatNumber: '座號',
  score: '分數',
  correctCount: '答對',
  wrongCount: '答錯',
  submitTime: '提交時間',
  prevPage: '上一頁',
  nextPage: '下一頁',
  loadScoresFailed: '載入成績失敗，請稍後再試',

  // HT 專屬功能（webview + HT 名單）
  awesome: '按讚',
  sendScores: '發送成績',
  clickToAwesome: '點擊按讚',
  noSeatNumber: '此學生無座號',
  awesomeSent: '按讚已發送',
  awesomeFailed: '發送按讚失敗',
  noScoresToSend: '目前沒有可發送的成績',
  noValidScores: '沒有有效的成績（需有座號）',
  scoresSent: '成績已發送',
  sendScoresFailed: '發送成績失敗',

  // Game template switching messages
  templateSwitchedNoScore: '偵測到變換模板，為維持公平，將不會提交成績！',
  switchGameTemplate: '切換遊戲模板',

  // User guide messages - Step 1, 2, 3 & 4
  gameActGuide: {
    step1: {
      main: '從這裡開始',
      sub: '建立你的第一個遊戲活動'
    },
    step2: {
      hint1: 'Step 1: 填寫遊戲設定（題目、答案、遊戲模板等）',
      hint2: 'Step 2: 點擊「遊戲預覽」確認沒問題',
      hint3: 'Step 3: 完成後點擊左上角「返回」按鈕',
      backButton: '完成後點這裡返回'
    },
    step3: {
      confirmButton: '點擊「確定」建立活動'
    },
    step4: {
      publishButton: '點擊「發布短網址」分享給學生'
    }
  },

  // Security check messages
  securityCheck: {
    title: '⚠️ 程式碼安全檢查發現以下問題',
    errorTitle: '🔴 嚴重問題',
    warningTitle: '⚠️ 警告',
    suggestionTitle: '建議',
    suggestion1: '避免使用 onclick, onerror 等 HTML 屬性',
    suggestion2: '改用 addEventListener 方式綁定事件',
    suggestion3: '避免使用巢狀 iframe, object, embed 標籤',
    continuePreview: '預覽仍會繼續,但建議修正這些問題以符合最佳實踐。'
  },

  // Roster uncheck confirmation (non-WebView)
  rosterUncheckConfirmTitle: '取消使用 HT 匯入名單',
  rosterUncheckConfirmMessage: '取消勾選並確定儲存後，將會清空此活動中已載入的 HT 名單；之後僅能於 HiTeach 內重新取得名單。',

  // Clear settings
  clearSettings: '清空設定',
  confirmClearSettings: '確定要清空所有設定嗎？',
  settingsCleared: '設定已清空',

  // Required field validation
  topicRequired: '請填寫主題',
  correctItemsRequired: '請至少新增一個答對題目',
  errorItemsRequired: '請至少新增一個答錯題目',
  questionListRequired: '請至少新增一個題目',
  requiredFieldsMissing: '以下欄位為必填：',

  // Activity usage display
  activityUsage: '遊戲活動用量',
  usageFormat: '{current} / {max}',

  // Activity limit exceeded
  activityLimitExceeded: '已達活動數量上限（{maxLimit} 個），請刪除部分活動後再試！'
};
